import React from 'react';
import CompareVariantsContainer from '../../elements/e-commerce/CompareOrderVariants/CompareVariantsContainer';

const CompareOrderVariants = () => {
  return <CompareVariantsContainer />;
};

export default CompareOrderVariants;
